import { createStore } from "vuex";
import { getDocs, collection } from "firebase/firestore";
import { db } from "@/firebase";

// Import stores
import knowledge from "./knowledge";
import facebook from "./facebook";
import posts from "./posts";
import inbox from "./inbox";
import users from "./users";
import schedules from "./schedules";
import media from "./media";
import templates from "./templates";
import admin from "./admin";
import workspace from "./workspace";
import notifications from "./notifications";
import chats from "./chats";
import ideas from "./ideas";
import post from "./post";
import structures from "./structures";
import template from "./template";
import medium from "./medium";
import accounts from "./accounts";
import agent from "./agent";
import categories from "./categories";
import support from "./support";
import sources from "./sources";
import subscription from "./subscription";
export default createStore({
  state: {
    password: false,
    openai: false,
    queue: false,
    onboarding: false,
    loading: {
      accounts: false,
      admin: {
        emails: false,
        workspaces: false,
        users: false,
        articles: false,
        calendar: false,
        posts: false,
        backlog: false,
        notifications: false,
      },
      calendar: false,
      calendar_next: false,
      categories: false,
      general: false,
      media: false,
      notifications: false,
      posts: false,
      schedules: false,
      userProfile: false,
      workspace: false,
      support: false,
      knowledge: false,
      ai: {
        generate: false,
        complete: false,
        translate: false,
        spelling: false,
        variation: false,
        anything: false,
        ideas: false,
      },
      chats: false,
      ideas: false,
      joining: false,
      sources: false,
      structures: false,
      templates: false,
      convertToPosts: "idle",
      convertedItemUids: [],
    },
    notification: {
      show: false,
      text: "Your post has beed added!",
      type: "primary",
      icon: "delete",
      redirect: "",
      action_text: "",
    },
    settings: null,
  },
  getters: {},
  mutations: {
    setLoading(state, val) {
      if (val.type.includes(".")) {
        let type = val.type.split(".");
        let a = type[0];
        let b = type[1];
        state.loading[a][b] = val.val;
      } else {
        state.loading[val.type] = val.val;
      }
    },
    setPassword(state, val) {
      state.password = val;
    },
    setNotification(state, val) {
      state.notification = val;
    },
    setOpenai(state, val) {
      state.openai = val;
    },
    setOnboarding(state, val) {
      state.onboarding = val;
    },
    setConvertToPosts(state, val) {
      state.loading.convertToPosts = val;
    },
    setConvertedItemUids(state, val) {
      state.loading.convertedItemUids = val;
    },
    setQueue(state, val) {
      state.queue = val;
    },
    setSettings(state, val) {
      state.settings = val;
    },
  },
  actions: {
    async getSettings({ commit }) {
      commit("setLoading", { type: "settings", val: true });
      const query = collection(db, "settings");
      const querySnapshot = await getDocs(query);
      let settings = {};
      querySnapshot.docs.map((doc) => {
        settings[doc.id] = doc.data();
      });
      console.log("settings:", settings);
      commit("setSettings", settings);
      commit("setLoading", { type: "settings", val: false });
    },
  },
  modules: {
    knowledge,
    accounts,
    admin,
    agent,
    categories,
    chats,
    facebook,

    inbox,
    ideas,
    users,

    media,

    medium,
    notifications,
    posts,
    post,
    structures,
    schedules,
    support,
    template,
    templates,
    sources,
    subscription,
    workspace,
  },
});
